import { Component, OnDestroy, OnInit } from '@angular/core';
import { NitrogenComplianceUi } from '../../service/Interface/WidgetConstant.interface';
import { WidgetRxjsService } from '../../service/rxjs/WidgetRxjs.service';
import { WidgetConstant } from '../../service/widgetHelper/WidgetConstant';
import { Subscription } from 'rxjs';
import { NitrogenComplianceWidget, NitrogenComplianceFitments, NitrogenComplianceWidgetVehicleResult } from '../../service/Interface/Widget.interface';

@Component({
    selector: 'widget-nitrogen-compliance',
    templateUrl: './nitrogen-compliance.component.html',
    styleUrls: ['./../../site-dashboard.component.scss']
})


export class SiteDashboardNitrogenComplianceComponent implements OnInit, OnDestroy{
    public ui: NitrogenComplianceUi;
    public nitrogenComplianceWidget: Subscription;
    public result: NitrogenComplianceWidget = {
        siteDashboardWidgetId: null,
        nitrogenEnabled: false,
        minimumNitrogen: 0,
        vehicles: [],
        hasReceivedResult: false
    };
    public selectedVehicles: NitrogenComplianceWidgetVehicleResult[];
    public listItems: Array<string> = [];
    public selectedFilterValue = "";

    constructor(private widgetRxjs: WidgetRxjsService, private constant: WidgetConstant) {
        this.ui = this.constant.getNitrogenComplianceWidgetUi();
        this.listItems.push(this.ui.all);
        this.listItems.push(this.ui.no);
        this.listItems.push(this.ui.yes);
        this.selectedFilterValue = this.ui.no;
    }

    ngOnInit(){
        this.subscribeNitrogenComplianceWidgetResult();
    }

    ngOnDestroy() {
        this.nitrogenComplianceWidget.unsubscribe();
    }

    private subscribeNitrogenComplianceWidgetResult() {
        this.nitrogenComplianceWidget = this.widgetRxjs.nitrogenComplianceWidget.subscribe(
            result => {
                //Loop here and set a Compliant field to true or false based on the rules in OR-12369
                result.vehicles.forEach((vehicle) => {
                    vehicle.compliant = this.checkVehicleNitrogenCompliance(vehicle.tyreFitments, result.minimumNitrogen)
                });
                this.result = result;
                this.selectedVehicles = result.vehicles.filter(v => v.compliant == false); //Filter to default value No
            });
    }

    private checkVehicleNitrogenCompliance(fitments: NitrogenComplianceFitments[], minimumNitrogen: number) : boolean {
        if (fitments.some(tf => tf.nitrogenFilled == false) || fitments.some(tf => tf.nitrogenPurity < minimumNitrogen)) {
            return false;
        };

        return true;
    }

    //Set the vehicleSerialNumber to search in vehicle/search
    setSearchBy(selectedSerialNumber: string) {
        localStorage.setItem('vehicleSerialNumber', selectedSerialNumber);
    }

    changeFilter(selectedValue: string) {
        if (selectedValue == this.ui.all) {
            this.selectedVehicles = this.result.vehicles;
        }
        else if (selectedValue == this.ui.yes) {
            this.selectedVehicles = this.result.vehicles.filter(v => v.compliant == true);
        } else {
            this.selectedVehicles = this.result.vehicles.filter(v => v.compliant == false);
        }
    }
}